module.exports = __webpack_public_path__ + "static/media/signal-alt.5b85e20b.svg";